export const data= [
    {   id: 1,
        questionText: 'What does CSS stand for?',
        answerOptions: [
            { answerText: 'CASCEDING STYLE SHEET', isCorrect: true },
            { answerText: 'COMPUTER STYLE SHEET', isCorrect: false },
            { answerText: 'COLOR STYLE SHEET', isCorrect: false },
            { answerText: 'CASCEDING STYLE SUPPORT', isCorrect: false },
        ]
    },
    {   
        id: 2,
        questionText: 'Who has created react-js library?',
        answerOptions: [
            { answerText: 'FACEBOOK', isCorrect: true },
            { answerText: 'GOOGLE', isCorrect: false },
            { answerText: 'AMAZON', isCorrect: false },
            { answerText: 'TESLA', isCorrect: false },
        ]
    },
    {
        id: 3,
        questionText: 'Who is CEO of Tesla?',
        answerOptions: [
            { answerText: 'Jeff Bezos', isCorrect: false },
            { answerText: 'Elon Musk', isCorrect: true },
            { answerText: 'Bill Gates', isCorrect: false },
            { answerText: 'Tony Stark', isCorrect: false },
        ]
    },
    {
        id: 4,
        questionText: 'The iPhone was created by which company?',
        answerOptions: [
            { answerText: 'Apple', isCorrect: true },
            { answerText: 'Intel', isCorrect: false },
            { answerText: 'Amazon', isCorrect: false },
            { answerText: 'Microsoft', isCorrect: false },
        ]
    },
    {
        id: 5,
        questionText: 'How many Harry Potter books are there?',
        answerOptions: [
            { answerText: '1', isCorrect: false },
            { answerText: '4', isCorrect: false },
            { answerText: '6', isCorrect: false },
            { answerText: '7', isCorrect: true },
        ]
    }
];